import $ from "jquery";
import * as preact from "preact";

import * as modalController from "modalController";
import * as premiumUpsellModal from "premiumUpsellModal";
import * as signupModal from "signupModal";
import Dialog from "views/Dialog";

export default function (response, stores, notify?, dismissNotification?) {
  if (response.data?.error) {
    switch (response.data.error) {
      case "notSignedIn":
        signupModal.show({
          heading: preact.h(preact.Fragment, {}, [
            "Sign in to translate ",
            preact.h("strong", {}, "phrases"),
          ]),
          stores: stores,
        });
        break;
      case "dailyLimit":
        if (stores.user.hasPremiumAccess.value) {
          alert(
            "You have reached a rate limit designed to prevent abuse of the service. If you " +
              "have hit this limit by normal use, please let me know at steve@readlang.com"
          );
        } else {
          premiumUpsellModal.show({
            title: "phraseLimit",
            phraseLimit: true,
            heading: "Get unlimited phrase translations...",
            showTitle: false,
          });
        }
        break;
      case "phraseLengthLimit": {
        let phraseLengthLimit;
        let upsell = "";

        if (
          /^(standard|freeForever|plus)$/.test(
            stores.user.state.value.subscriptionPlan
          )
        ) {
          phraseLengthLimit = 12;
        } else {
          phraseLengthLimit = 6;
          upsell =
            '<br><a href="#" id="phraseLengthUpsell"><i class="icon-rocket"></i> ' +
            "Increase to 12 words" +
            "</a>.";
        }

        notify?.({
          htmlMessage:
            "Limit of " + phraseLengthLimit + " words per phrase. " + upsell,
          element: $(".container"),
          time: 8000,
          callback: () => {
            $("#phraseLengthUpsell").click((event) => {
              event.preventDefault();
              event.stopPropagation();
              premiumUpsellModal.show({
                title: "phraseLengthLimit",
                heading: "Upgrade to increase phrase length limit",
                showTitle: false,
              });
              dismissNotification?.();
            });
          },
        });
        break;
      }
      default: {
        modalController.show(
          preact.h(
            Dialog,
            { heading: "Translate Error" },
            preact.h("p", {}, response.data.error)
          )
        );
      }
    }
  }
}
